<script setup lang="ts">
type StudentUserData = App.Auth.Data.StudentUserData;
type TwoFactorChannelData = App.Auth.Data.TwoFactorChannelData;

// Badge props handled by CardListItem so no badge imports needed
import { ButtonColor, ButtonSize, ButtonVariant } from '@/hooks/useButtonClasses';

import Button from '@/components/button/Button.vue';
import Dialog from '@/components/dialog/Dialog.vue';
import Fieldset from '@/components/fieldset/Fieldset.vue';
import TextInput from '@/components/textInput/TextInput.vue';
import CardList from '@/components/studentParentApp/card/CardList.vue';
import CardListItem from '@/components/studentParentApp/card/CardListItem.vue';

import Wrench from '@/icons/line/wrench.svg';
import Plus from '@/icons/line/plus.svg';
import Lock from '@/icons/line/lock.svg';

defineProps<{
  user: StudentUserData;
  channels: TwoFactorChannelData[];
}>();

const { show, close } = useDialog();
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/student-parent.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <Dialog hideFooter title="Password & 2FA" :isOpen="show" @onClose="close">
    <template #form>
      <div class="flex flex-col gap-y-8">
        <Fieldset title="Password">
          <div class="flex flex-col gap-y-5">
            <TextInput modelValue="••••••••••••" isDisabled />
            <Button
              :color="ButtonColor.slate"
              :href="route('student.profile.security.password.edit')"
              :iconLeft="Wrench"
              :variant="ButtonVariant.soft"
              :size="ButtonSize.lg"
            >
              Change password
            </Button>
          </div>
        </Fieldset>
        <Fieldset title="Two-factor authentication">
          <CardList>
            <CardListItem
              v-for="channel in channels"
              :href="
                channels.length > 1
                  ? route('student.profile.security.two-factor-authentication-channel.show', {
                      channel: channel.id
                    })
                  : undefined
              "
              :key="channel.id"
              :icon="Lock"
              :label="channel.channelTypeDisplayName"
              :value="channel.formattedDestination"
              :badgeLabel="
                user.default_two_factor_channel_id === channel.id ? 'default' : undefined
              "
            />
          </CardList>
          <Button
            :color="ButtonColor.slate"
            :iconLeft="Plus"
            :href="route('student.profile.security.two-factor-authentication-channel.create')"
            :variant="ButtonVariant.soft"
            :size="ButtonSize.lg"
          >
            Add 2FA method
          </Button>
        </Fieldset>
      </div>
    </template>
  </Dialog>
</template>
